import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-foreground-400 text-sm tracking-wide mb-2">最新爆料</p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold">
              最新吃瓜网站黑料
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-md leading-relaxed">
            每日更新最新网红塌房、黑料爆料、娱乐八卦，让你不错过任何一个大瓜。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                {article.isExclusive && (
                  <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                    独家
                  </span>
                )}
                {article.isHot && (
                  <span className="absolute top-3 right-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                    <i className="ri-fire-line mr-1"></i>热门
                  </span>
                )}
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                <span className="inline-block bg-secondary-100 text-secondary-800 text-xs px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 font-bold mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.readCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <Link
            to="/category/heiliao-baoliao"
            className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看更多爆料 <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}